import React, { Fragment } from "react";
import _ from "lodash";

import StatusIndicator from "./StatusIndicator";
import LeaderActions from "../LeaderActions";

const MenuItem = ({ item }) => {

  const renderContent = () => {
    return (
      <Fragment>
        <span>{item.title}</span>
        {item.status ? <StatusIndicator status={item.status} /> : null}
      </Fragment>
    );
  }

  return (
    <div className="menu-item-wrapper">
      <li className={`menu-item ${item?.selected ? "selected" : null}`}>
        {item?.onClick ? (
          <button
            className={`${item.className ? item.className : ""}`}
            title={item?.tooltip}
            disabled={!item?.clickable}
            onClick={() => item?.onClick && item?.onClick(_.omit(item, "onClick"))}
          >
            {renderContent()}
          </button>
        ) : (
          <a
            className={`${item.className ? item.className : ""} ${item?.clickable ? "" : "disabled"}`}
            href={item.url}
            title={item?.tooltip}
          >
            {renderContent()}
          </a>
        )}
        <div className="separator"></div>
        <LeaderActions plan={item} />
      </li>
    </div>
  );
}

export default MenuItem;
